.tasks-table-container td:has([data-row-type='group']) {
    background-color: var(--off-white);
}

.tasks-table-container td:has([data-row-type='total']) {
    background-color: var(--blue-xlt);
}
